import { AMEX_PARTNER_NAME } from './constants';

export class PartnerName {
  constructor(private readonly partnerName: string) {}

  public requiresActiveTermsAndConditionsConsent() {
    return this.isAmex();
  }

  private isAmex() {
    return this.partnerName === AMEX_PARTNER_NAME;
  }
}
